import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import LandingPage from "../Pages/Customer/LandingPage";
import PricingPage from "../Pages/Customer/PricingPage";
import AboutPage from "../Pages/Customer/AboutPage";
import ContactPage from "../Pages/Customer/Page/ContactPage";
import DetailsPage from "../Pages/Customer/Page/DetailsPage";
import ClientsDirectory from "../Components/ClientsDirectory";
import AdminLogin from "../Pages/Admin/AdminLogin";
import AdminDashboard from "../Pages/Admin/AdminDashboard";

export default function AppRoutes() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/aboutUs" element={<AboutPage />} />
        <Route path="/contactUs" element={<ContactPage />} />
        <Route path="/details" element={<DetailsPage />} />
        <Route path="/clients" element={<ClientsDirectory />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}
